import { InfoTile } from '../../info-tile/InfoTile'
import { MarketSparkRewards } from '@/features/spark-rewards/types'
import { SparkRewardPill } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'

export interface SparkRewardsInfoTileProps {
  sparkRewards: MarketSparkRewards[]
}

export function SparkRewardsInfoTile({ sparkRewards }: SparkRewardsInfoTileProps) {
  if (sparkRewards.length === 0) {
    return null
  }

  const label = sparkRewards.some((reward) => reward.apy) ? 'Rewards APY' : 'Rewards'

  return (
    <InfoTile>
      <InfoTile.Label>{label}</InfoTile.Label>
      <InfoTile.Value>
        <div className="flex items-stretch gap-0.5 sm:flex-col">
          {sparkRewards.map((reward) => (
            <SparkRewardPill key={reward.rewardTokenSymbol} {...reward} />
          ))}
        </div>
      </InfoTile.Value>
    </InfoTile>
  )
}
